/**
 * Thời gian tương đối kiểu Facebook: "Vừa xong", "10 giây trước", "20 phút trước",
 * "3 giờ trước", "3 ngày trước" → quá 7 ngày thì hiện ngày tháng cho dễ đọc.
 * Mirror của mobile/src/shared/utils/format-time-ago.ts — sửa luật phải sửa cả 2 nơi.
 */

/** Ngưỡng phân biệt epoch giây / mili-giây (01/01/2000) */
const MS_THRESHOLD = 946684800000;

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

/** createTime có thể là epoch giây hoặc mili-giây — chuẩn hoá về mili-giây */
export function toMilliseconds(value) {
    if (!value) return 0;
    return value < MS_THRESHOLD ? value * 1000 : value;
}

/** Ngày tháng tuyệt đối: cùng năm bỏ năm cho gọn ("12 tháng 9"), khác năm thêm năm */
function formatAbsoluteDate(date, now) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    return date.getFullYear() === now.getFullYear()
        ? `${day} tháng ${month}`
        : `${day}/${month}/${date.getFullYear()}`;
}

/**
 * @param {number} createTime epoch giây hoặc mili-giây
 * @param {number} [nowMs] mốc "hiện tại" (chỉ dùng cho test)
 */
export function formatTimeAgo(createTime, nowMs = Date.now()) {
    const ms = toMilliseconds(createTime);
    if (!ms) return '';

    const diffSec = Math.floor((nowMs - ms) / 1000);

    // Lệch giờ máy / thông báo hẹn giờ ở tương lai → coi như vừa xong
    if (diffSec < 5) return 'Vừa xong';
    if (diffSec < MINUTE) return `${diffSec} giây trước`;
    if (diffSec < HOUR) return `${Math.floor(diffSec / MINUTE)} phút trước`;
    if (diffSec < DAY) return `${Math.floor(diffSec / HOUR)} giờ trước`;
    if (diffSec < WEEK) return `${Math.floor(diffSec / DAY)} ngày trước`;

    return formatAbsoluteDate(new Date(ms), new Date(nowMs));
}

/** Ngày giờ đầy đủ kiểu "16/09/2026 05:30" */
export function formatFullDateTime(createTime) {
    const ms = toMilliseconds(createTime);
    if (!ms) return '';
    const d = new Date(ms);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
